import script from "./itemCardBig.vue?vue&type=script&setup=true&lang=js"
export * from "./itemCardBig.vue?vue&type=script&setup=true&lang=js"

import "./itemCardBig.vue?vue&type=style&index=0&id=79044bc2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79044bc2"]])

export default __exports__